"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimDocumentType = void 0;
var ClaimDocumentType;
(function (ClaimDocumentType) {
    ClaimDocumentType[ClaimDocumentType["AppraisalReports"] = 1] = "AppraisalReports";
    ClaimDocumentType[ClaimDocumentType["ReportsOrInspections"] = 2] = "ReportsOrInspections";
    ClaimDocumentType[ClaimDocumentType["Quotes"] = 3] = "Quotes";
    ClaimDocumentType[ClaimDocumentType["Invoices"] = 4] = "Invoices";
    ClaimDocumentType[ClaimDocumentType["UnderwritingDocumentation"] = 5] = "UnderwritingDocumentation";
    ClaimDocumentType[ClaimDocumentType["InsuranceSettlementDocumentation"] = 6] = "InsuranceSettlementDocumentation";
    ClaimDocumentType[ClaimDocumentType["JudgementDocumentation"] = 7] = "JudgementDocumentation";
    ClaimDocumentType[ClaimDocumentType["BankruptcyDocumentation"] = 8] = "BankruptcyDocumentation";
    ClaimDocumentType[ClaimDocumentType["TitleDocumentation"] = 9] = "TitleDocumentation";
    ClaimDocumentType[ClaimDocumentType["CreditReport"] = 10] = "CreditReport";
    ClaimDocumentType[ClaimDocumentType["SettlementInLieuOfJudgement"] = 11] = "SettlementInLieuOfJudgement";
    ClaimDocumentType[ClaimDocumentType["StatementOfAdjustment"] = 12] = "StatementOfAdjustment";
    ClaimDocumentType[ClaimDocumentType["Miscellaneous"] = 13] = "Miscellaneous";
    ClaimDocumentType[ClaimDocumentType["CmhcUseOnly"] = 14] = "CmhcUseOnly";
})(ClaimDocumentType = exports.ClaimDocumentType || (exports.ClaimDocumentType = {}));
